export default "__VITE_PUBLIC_ASSET__890cc2c6__"